import React from 'react';
import { connect } from 'react-redux';
import { closeRoulette } from '../../actions/actions';
import $ from 'jquery';
import '../../../vendor/roulette';
import './style.scss';

export class Roulette extends React.Component {
  componentWillMount() {
    this.roulette = null;
  }

  componentDidMount() {
    let option = {
      speed : 30,
      duration : 2,
      stopImageNumber : -1,
      startCallback : function() {
        $('.roulette-title').text("... drumroll please ...");
        $('.do-roulette').hide();
      },
      slowDownCallback : function() {
        $('.roulette-title').text("... slowing down ...");
      },
      stopCallback : function() {
        $('.roulette-title').text("Woohooooo! We've got a winner!");
        // console.log('stop', $stopElm);
      }
    };

    this.roulette = $('div.roulette').roulette(option);
  }

  closeRoulette() {
    this.props.closeRoulette();
  }

  start() {
    this.roulette.roulette('start');
  }

  render() {
    return (
      <div className="whiteout">
        <div className="flexModal rouletteModal">
          <div className="flexModal__inner">
            <div className="flexModal__header">
              <h1 className="roulette-title">Hit that button and start LuckySpin!</h1>
              <button className="btn-icon" onClick={this.closeRoulette.bind(this)}><span className="icon-cross"/></button>
            </div>
            <div className="flexModal__body">
              <div className="roulette-holder">
                <div className="roulette">
                  {
                    this.props.rewards.map(
                      (reward, index) => {
                        if(reward.selected) {
                          return (
                            <img key={index} src={"/images/" + reward.image} />
                          );
                        }
                      }
                    )
                  }
                </div>
              </div>
            </div>
            <div className="flexModal__footer">
              <button className="btn do-roulette" onClick={this.start.bind(this)}>Spin it!</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Roulette.propTypes = {
  closeRoulette: React.PropTypes.func,
  rewards: React.PropTypes.array
};

export default connect(null, {closeRoulette})(Roulette);



/** WEBPACK FOOTER **
 ** ./src/components/roulette/index.js
 **/